import config from "./index";

/** Config keys that may be overridden per data-residency region. */
type RegionalKey = "GHL_DOMAIN_UI" | "FORM_EMBED_URL";

/**
 * Environment → region → config key → host override, for data-residency regions.
 * List only hosts that differ from the env default; anything absent falls back to
 * `config[key]`. Env keys match `config.mode`. Only AU staging is provisioned today.
 *
 * `GHL_DOMAIN_UI` is the version-history preview host; `FORM_EMBED_URL` is the
 * non-white-labelled embed-script host (white-labelled embeds use the tenant domain).
 */
const REGIONAL_OVERRIDES: Record<
  string,
  Record<string, Partial<Record<RegionalKey, string>>>
> = {
  staging: {
    au: {
      GHL_DOMAIN_UI: "https://funnel-preview-dot-hl-app-stg-au.ts.r.appspot.com",
      FORM_EMBED_URL: "https://staging-au.link.gohighlevel.com/js",
    },
  },
  // production: {
  //   au: {
  //     GHL_DOMAIN_UI: "<prod-au-host>",
  //     FORM_EMBED_URL: "<prod-au-host>/js",
  //   },
  // },
};

/**
 * Resolve a key for a region, falling back to the env default.
 * @param regionCode from the Postmate model (JWT-derived); may be undefined.
 */
const resolveForRegion = (key: RegionalKey, regionCode?: string): string => {
  const region = regionCode?.trim()?.toLowerCase();
  const override = region
    ? REGIONAL_OVERRIDES[config.mode]?.[region]?.[key]
    : undefined;
  return override || config[key];
};

/** Preview/widget host for a tenant's data-residency region. */
export const getGhlDomainUiForRegion = (regionCode?: string): string =>
  resolveForRegion("GHL_DOMAIN_UI", regionCode);

/** Embed-script host for a tenant's data-residency region. */
export const getFormEmbedUrlForRegion = (regionCode?: string): string =>
  resolveForRegion("FORM_EMBED_URL", regionCode);
